import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserModel } from '@app/core/model/user.model';
import {
  TSpecQueryGetAttendanceBonusHistory,
  TSpecRoute_getAttendanceBonusHistory
} from '@backend/types/generated/AttendanceBonuses/getAttendanceBonusHistory';
import { TSpecRoute_getPendingAttendanceBonuses } from '@backend/types/generated/AttendanceBonuses/getPendingAttendanceBonuses';
import {
  TSpecBodyPostApproveAttendanceBonus,
  TSpecPathPostApproveAttendanceBonus,
  TSpecRoute_postApproveAttendanceBonus
} from '@backend/types/generated/AttendanceBonuses/postApproveAttendanceBonus';
import {
  TSpecBodyPostExcuseAttendanceBonus,
  TSpecPathPostExcuseAttendanceBonus,
  TSpecRoute_postExcuseAttendanceBonus
} from '@backend/types/generated/AttendanceBonuses/postExcuseAttendanceBonus';
import {
  TSpecBodyPostRejectAttendanceBonus,
  TSpecPathPostRejectAttendanceBonus,
  TSpecRoute_postRejectAttendanceBonus
} from '@backend/types/generated/AttendanceBonuses/postRejectAttendanceBonus';
import { Observable } from 'rxjs';

export enum AttendanceBonusStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  EXCUSED = 'EXCUSED',
  REJECTED = 'REJECTED'
}

export interface AttendanceBonusModel {
  _id: string;
  tenant: string;
  user: UserModel;
  date: string;
  scheduledStart: string;
  clockIn: string;
  minutesLate: number;
  homebaseTimecardId: number;
  status: AttendanceBonusStatus;
  points: number;
  ledger?: string | null;
  note?: string;
  createdAt: string;
  updatedAt: string;
}

export interface AttendanceBonusHistoryResponse {
  items: AttendanceBonusModel[];
  total: number;
}

@Injectable({ providedIn: 'root' })
export class AttendanceBonusApiService {
  public constructor(private readonly _httpClient: HttpClient) {}

  public getPendingAttendanceBonuses(): Observable<AttendanceBonusModel[]> {
    return this._httpClient.get<AttendanceBonusModel[]>(
      TSpecRoute_getPendingAttendanceBonuses()
    );
  }

  public getAttendanceBonusHistory(params?: {
    query?: TSpecQueryGetAttendanceBonusHistory;
  }): Observable<AttendanceBonusHistoryResponse> {
    const query = params?.query;
    return this._httpClient.get<AttendanceBonusHistoryResponse>(
      TSpecRoute_getAttendanceBonusHistory(),
      { params: query as any }
    );
  }

  public approveAttendanceBonus(params: {
    path: TSpecPathPostApproveAttendanceBonus;
    body: TSpecBodyPostApproveAttendanceBonus;
  }): Observable<AttendanceBonusModel> {
    return this._httpClient.post<AttendanceBonusModel>(
      TSpecRoute_postApproveAttendanceBonus(params.path),
      params.body
    );
  }

  public excuseAttendanceBonus(params: {
    path: TSpecPathPostExcuseAttendanceBonus;
    body: TSpecBodyPostExcuseAttendanceBonus;
  }): Observable<AttendanceBonusModel> {
    return this._httpClient.post<AttendanceBonusModel>(
      TSpecRoute_postExcuseAttendanceBonus(params.path),
      params.body
    );
  }

  public rejectAttendanceBonus(params: {
    path: TSpecPathPostRejectAttendanceBonus;
    body: TSpecBodyPostRejectAttendanceBonus;
  }): Observable<AttendanceBonusModel> {
    return this._httpClient.post<AttendanceBonusModel>(
      TSpecRoute_postRejectAttendanceBonus(params.path),
      params.body
    );
  }
}
